export default __webpack_public_path__ + "static/media/element_8.a016af44.jpg";